// ✅ Trekkin.app — useGPSHybrid facade (iOS vs Android)
import { Capacitor } from "@capacitor/core";
import useGPSHybridAndroid from "./useGPSHybrid.android.js";
import useGPSHybridiOS from "./useGPSHybrid.ios.js";

export default function useGPSHybrid(options = {}) {
  const platform = Capacitor?.getPlatform?.() || "";
  if (platform === "android") {
    return useGPSHybridAndroid(options);
  }
  return useGPSHybridiOS(options);
}
